import React from "react";
import CustomButton from "./CustomButton";

const CustomModel = ({
  isOpen,
  isClose,
  title,
  img,
  onConfirm,
  onConfirmText,
  content,
  loading,
  width = "w-[560px]",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className={`bg-white rounded-[10px] shadow-xl ${width}   p-6 transform transition-all`}>
        {/* Header */}
        <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
          <div
            id="bulk-upload-title"
            className="text-lg font-medium text-green-700"
          >
            <div className="bg- cursor-pointer flex items-center justify-center gap-2 text-base text-customGreen font-medium s w-full rounded-[10px] p-2">
              {img && <img src={img} alt="icon" className="w-6 h-6" />}

              <div>{title}</div>
            </div>
          </div>
          <button
            onClick={isClose}
            className="text-red-600 bg-white px-2 focus:outline-none  rounded-full p-1"
            aria-label="Close modal"
          >
            <svg
              className="w-5 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="py-4">{content}</div>

        {onConfirm && (
          <>
            <div className="flex justify-center items-center">
              <CustomButton
                onClick={onConfirm}
                label={onConfirmText}
                isDisabled={loading}
                className={"w-1/2 felx justify-center"}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomModel;
